import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { IApplicationState, SwapActionCreators, AppActionCreators, ISwapState, ISwapLookupDataResponse, IRccapLookupDataResponse, ISwapLookupDataCenterListResponse } from '@nkr/store/index';
import { IClusterListResponse } from '@nkr/models/index';
import { ChainStatus } from '@nkr/enums/index';
import SwapList from './swap-list/swap-list';

interface IOwnProps {
    chainStatusId: number,
    clusterStatusId: number
}

interface IStateProps {
    swaps: ISwapState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    setSwaps: () => void,
    getSwaps: (chainStatus: number, status: number) => Promise<IClusterListResponse>,
    getLookupData: () => Promise<ISwapLookupDataResponse>,
    getRccapLookupData: () => Promise<IRccapLookupDataResponse>,
    getLookupDataCenterList: () => Promise<ISwapLookupDataCenterListResponse>
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

class Swaps extends React.Component<TProps, {}> {
    componentDidMount() {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Loading swaps, one moment please...').then(() => {
            this.props.setSwaps();

            if (this.props.chainStatusId != ChainStatus.Ended) {
                return Promise.all(
                    [
                        this.props.getSwaps(this.props.chainStatusId, this.props.clusterStatusId),
                        this.props.getLookupData(),
                        this.props.getRccapLookupData(),
                        this.props.getLookupDataCenterList()
                    ]).then(() => {
                        this.props.hideLoading();
                    });
            } else {
                return Promise.all(
                    [
                        this.props.getLookupData(),
                    ]).then(() => {
                        this.props.hideLoading();
                    });
            }
        });
    }

    render() {
        return (
            <div>
                <SwapList
                    chainStatusId={this.props.chainStatusId}
                    clusterStatusId={this.props.clusterStatusId}
                />
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        swaps: state.swaps
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        setSwaps: () => {
            return dispatch(SwapActionCreators.setSwaps([]));
        },
        getSwaps: (chainStatus, status) => {
            return dispatch(SwapActionCreators.getSwaps(chainStatus, status, true));
        },
        getLookupData: () => {
            return dispatch(SwapActionCreators.getLookupData());
        },
        getRccapLookupData: () => {
            return dispatch(SwapActionCreators.getRccapLookupData());
        },
        getLookupDataCenterList: () => {
            return dispatch(SwapActionCreators.getCenterList());
        },
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(Swaps);